<template>
  <div
      class="xxl:w-[326px] flex flex-col  lg:justify-between h-full gap-[8px] border border-gray-400 rounded p-[16px]"
  >
    <div class="flex flex-col gap-[8px]">
      <div class="flex flex-col gap-[4px]">
        <p class="text-grays-600 text-sm font-medium">שם תחנה</p>
        <h3 class="text-primary-700 text-xl font-medium">{{ station.name }}</h3>
      </div>
      <div class="flex flex-col gap-[4px]">
        <div class="flex flex-row gap-[4px]">
          <div
              class="flex justify-center items-center h-[20px] w-[20px] rounded-full text-grays-900"
          >
            <span class="material-symbols-rounded text-xl">location_on</span>
          </div>
          <p class="text-grays-900 font-medium text-base">
            {{ station.street }}
          </p>
        </div>
        <div class="flex flex-row gap-[4px]">
          <div
              class="flex justify-center items-center h-[20px] w-[20px] rounded-full text-grays-900"
          >
            <span class="material-symbols-rounded text-xl"
            >assistant_navigation</span
            >
          </div>
          <p class="text-grays-900 font-medium text-base">
            {{ station.address_description }}
          </p>
        </div>
        <div class="flex flex-row gap-[4px]">
          <div
              class="flex justify-center items-center h-[20px] w-[20px] rounded-full text-grays-900"
          >
            <span class="material-symbols-rounded text-xl">calendar_today</span>
          </div>
          <p class="text-grays-900 font-medium text-base">
            {{ findDay(station.distribution_day) }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-row justify-start lg:justify-between">
      <div class="flex flex-row items-center gap-[4px]">
        <div class="">
          <img
              alt="Visa"
              class="w-6 h-6"
              src="/src/assets/icons/global/multiple_stop.svg"
          />
        </div>
        <p class="text-sm text-grays-700 font-medium pl-3 lg:pl-0">
          {{ formatDistance(station.distance) }}
        </p>
      </div>
      <div class="flex flex-row">
        <button-tertiary
            v-if="station.id !== selectedStation"
            @click="handleStation"
        >
          בחר תחנה
        </button-tertiary>
        <button-primary v-else @click="handleStation">
          בחרנו את התחנה הזו
        </button-primary>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonPrimary from "@/components/Global/ButtonPrimary.vue";
import ButtonTertiary from "@/components/Global/ButtonTertiary.vue";

export default {
  name: "station",
  components: {ButtonTertiary, ButtonPrimary},
  props: {
    station: {
      type: Object,
      required: true,
    },
    selectedStation: {
      required: true,
    },
  },
  data() {
    return {
      daysOfWeek: [
        "יום ראשון",
        "יום שני",
        "יום שלישי",
        "יום רביעי",
        "יום חמישי",
        "יום שישי",
        "יום שבת",
      ],
    };
  },
  methods: {
    handleStation() {
      this.$emit("station-selected", this.station.id);
    },
    findDay(weekNumber) {
      return this.daysOfWeek[weekNumber - 1];
    },
    formatDistance(distance) {
      let roundedDistance =
          distance >= 1 ? distance : (Math.round(distance / 50) * 50) / 1000;
      if (distance < 1) {
        return Math.round(distance * 1000) + "m";
      } else if (Number.isInteger(roundedDistance)) {
        return roundedDistance + "km";
      } else {
        return roundedDistance.toFixed(1) + "km"; // Display with one decimal place for others
      }
    },
  },
};
</script>

<style>
</style>